import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { useDispatch, useSelector } from "react-redux";
import { setOpenAdvanceSearch } from "../../../reduxStore/SettingsReducer";
import zIndex from "@mui/material/styles/zIndex";
import { styled } from "@mui/material";

const CustomDrawer = styled(Drawer)(({ theme }) => ({
  // zIndex: '2147483647 !important', // Set your desired z-index value
}));

export default function MuiSideFilter(props) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const dispatch = useDispatch();

  const open_advance_search = useSelector(
    (state) => state.settingsData.open_advance_search
  );
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    dispatch(setOpenAdvanceSearch(false))
    if(props.setOpen)props?.setOpen(false);
  };


  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {["All mail", "Trash", "Spam"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <CustomDrawer
      anchor={'right'}
      open={props?.open?props?.open:open_advance_search}
      onClose={toggleDrawer("left", false)}
      sx={{
        width:props?.width?props?.width:'350px !important',
        '& .MuiPaper-root':{
            width:props?.width?props?.width:'395px !important',
            backgroundColor:props?.backgroundColor?props?.backgroundColor:'',
            boxShadow:props?.boxShadow?props?.boxShadow:'',
            zIndex:'2147483647 !importantg'
        },
        zIndex:'2147483647 !importantg'
      }}
      className="CustomDrawer"
    >
      {props?.children}
    </CustomDrawer>
  );
}
